import React from "react";
import shallowequal from "shallowequal";
import filter from "../../filter";
import {executeQuery} from "../../requests/executeQuery";
import {renderPrintFooter} from '../../utils';
import {TEXAS_MARKET_SHARE} from '../../consts/queries';
import MarketReport from "../MarketReport";
import { reportTypes } from "../../consts/consts";

export default class MarketShareReport extends MarketReport {
    constructor(props) {
        super(props);
    }

    componentDidMount() {        
        this.setState({printBackground: `url('${arc.path.media+'Transaction_Background.png'}')`});
        window.onbeforeprint = this.beforePrint;
        window.onafterprint = this.afterPrint;
        this.fetch(this.props.location.query);
        window.history.replaceState(null, '');
    }

    componentDidUpdate(prevProps) {
        if (!shallowequal(prevProps.location.query, this.props.location.query)) {
            this.fetch(this.props.location.query);
        }
    }

    fetch(q) {
        const query = {...q};

        const year = new Date().getFullYear();
        const optionsTexasSTNL = filter({...query, TYPE: 'STNL'}, 'market-share');
        const optionsTexasMT = filter({...query, TYPE: 'MT'}, 'market-share');        
        const optionsStriveSTNL = filter({...query, SOURCE:'SUMMIT', TYPE: 'STNL'}, 'market-share');
        const optionsStriveMT = filter({...query, SOURCE:'SUMMIT', TYPE: 'MT'}, 'market-share');
    
        const requests = [
            executeQuery({queryName: TEXAS_MARKET_SHARE, options: optionsTexasSTNL}),
            executeQuery({queryName: TEXAS_MARKET_SHARE, options: optionsStriveSTNL}),
            executeQuery({queryName: TEXAS_MARKET_SHARE, options: optionsTexasMT}),
            executeQuery({queryName: TEXAS_MARKET_SHARE, options: optionsStriveMT}),
        ];

        Promise.all(requests).then(res => {
            if (res && res[0] && res[0].data && Array.isArray(res[0].data) &&
                res[1] && res[1].data && Array.isArray(res[1].data) &&
                res[2] && res[2].data && Array.isArray(res[2].data) &&
                res[3] && res[3].data && Array.isArray(res[3].data)) {

                const transactions = [];
                transactions.STNL = MarketReport.buildTableData({prevData: res[0].data[0], data: res[1].data[0], type: 'STNL'});
                transactions.MT = MarketReport.buildTableData({prevData: res[2].data[0], data: res[3].data[0], type: 'MT'});

                this.setState({
                    query,
                    year,
                    transactions
                });
                return;
            }

            this.setState({
                query,
                year
            });
        });
    }

    render() {
        const {query, transactions, year, isPrint, printBackground} = this.state;
        const reportType = reportTypes.MarketShare;

        return (
            <div className='MarketReport'>
                <div className='print-container' style={{backgroundImage: isPrint && printBackground}}>
                    {MarketReport.renderMarketTable({reportType:reportType, data: transactions.MT, type: 'Multi-Tenant', market: query.MARKET, year})}
                    {renderPrintFooter(isPrint)}
                </div>
                <div className='print-container' style={{backgroundImage: isPrint && printBackground}}>
                    {MarketReport.renderMarketTable({reportType:reportType, data: transactions.STNL, type: 'Single-Tenant', market: query.MARKET, year})}
                    {renderPrintFooter(isPrint)}
                </div>
                <div className='preload-print-background' style={{backgroundImage: printBackground}}/>
            </div>
        )
    }
}